export const en = {
  // Header Navigation
  nav: {
    home: "HOME",
    company: "XIAMEN TOWER TECH",
    sourcing: "SOURCING",
    otherServices: "OTHER SERVICES",
    projects: "PROJECTS",
    blog: "BLOG",
    partners: "Partners",
    contact: "CONTACT"
  },
  
  // Hero Section
  hero: {
    title: "Sourcing risk-free",
    titleHighlight: "risk-free",
    subtitle: "FROM CHINA",
    description1: "From the factory to your warehouse,",
    description1Highlight: "without surprises.",
    description2: "We monitor every stage so that your business can grow",
    description2Highlight: "without worries.",
    startSourcing: "Start Sourcing",
    learnMore: "Learn More"
  },

  // About Section
  about: {
    title: "About Xiamen Tower Technology Co., Ltd.",
    description: "Founded in 2019, Xiamen Tower Technology Co., Ltd. is a leading import-export and product sourcing company based in Fujian Province, China. We specialize in connecting international businesses with reliable Chinese manufacturers, ensuring quality, efficiency, and seamless supply chain management.",
    feature1Title: "Multilingual Team",
    feature1Description: "We speak English, German, Spanish, Slovenian, and Serbian, ensuring clear communication throughout the entire process.",
    feature2Title: "Global Delivery Support",
    feature2Description: "We assist clients worldwide with seamless shipping, logistics, and end-to-end delivery solutions.",
    feature3Title: "Verified Manufacturer Network",
    feature3Description: "We collaborate only with trusted, factory-audited suppliers for quality and consistency."
  },

  // Services Section
  services: {
    title: "Our Services",
    description: "We provide comprehensive solutions for your sourcing and manufacturing needs in China.",
    subtitle: "We can help you with one or more stages",
    mainTitle: "Sourcing Services",
    sourcingTitle: "Sourcing",
    otherServicesTitle: "Other Services",
    sourcingDescription1: "We take care of the entire sourcing process: from finding the ideal supplier and developing the product to rigorous quality controls and optimized logistics.",
    sourcingDescription2: "More than just an intermediary, we are a partner in global purchasing, guaranteeing efficiency, savings and security in every import.",
    otherServicesDescription1: "We offer a range of complementary sourcing services that enable you to tackle your internationalization projects with confidence.",
    otherServicesDescription2: "From strategic consulting to accessing new markets, our team acts as a true partner in the global growth of your company.",
    hideDetails: "Hide Details",
    showInfo: "+ INFO",
    moreInfo: "More Info",
    process: "Our Process",
    benefits: "Key Benefits",
    supplierSelection: {
      title: "Supplier Selection",
      description: "We identify and validate reliable manufacturers in China that meet your specific needs and quality standards.",
      steps: {
        step1: "Requirements analysis and market research",
        step2: "Identification and pre-selection of qualified suppliers",
        step3: "Factory visits and technical assessments",
        step4: "Supplier verification and certification review"
      },
      benefits: {
        benefit1: "Access to verified premium manufacturers",
        benefit2: "Minimized risk through strict supplier vetting",
        benefit3: "Reduced lead time for supplier qualification"
      }
    },
    productDevelopment: {
      title: "Product Development",
      description: "We transform your idea into a viable, high-quality product — from concept to mass production — ensuring top standards and full guarantees.",
      steps: {
        step1: "Technical specifications and design requirements",
        step2: "Prototyping and sample creation",
        step3: "Technical optimization and cost analysis",
        step4: "Production preparations and tooling setup"
      },
      benefits: {
        benefit1: "Design focused on manufacturability and scalability",
        benefit2: "Faster time-to-market",
        benefit3: "Continuous improvement based on real-world feedback"
      }
    },
    qualityControl: {
      title: "Quality Control",
      description: "We supervise every stage of production to ensure full compliance, consistency, and excellence in every batch manufactured.",
      steps: {
        step1: "Material inspection and pre-production checks",
        step2: "In-process monitoring (DUPRO)",
        step3: "Final inspection before shipment (PSI)",
        step4: "Detailed reports with photo documentation"
      },
      benefits: {
        benefit1: "Early detection of quality issues",
        benefit2: "Reduced returns and warranty claims",
        benefit3: "Consistent quality level across all batches"
      }
    },
    logisticsManagement: {
      title: "Logistics Management",
      description: "We coordinate the entire supply chain for efficient and successful imports from China to your warehouse.",
      steps: {
        step1: "Selection and negotiation with logistics partners",
        step2: "Customs clearance and export documentation",
        step3: "Container consolidation and shipment optimization",
        step4: "Real-time tracking until final delivery"
      },
      benefits: {
        benefit1: "Optimized shipping costs through smart routing",
        benefit2: "Faster delivery with express options",
        benefit3: "Full shipment insurance and cargo protection"
      }
    }
  },

  // Global Reach Section
  globalReach: {
    title: "Global Reach",
    description: "With our strong supplier network and on-the-ground expertise in China, we support clients worldwide with reliable sourcing, quality inspections, and end-to-end project coordination across multiple industries.",
    feature1Title: "🌍 Countries Served",
    feature1Description: "Supporting clients across all major global regions.",
    feature2Title: "🤝 International Clients",
    feature2Description: "Trusted by businesses in Europe, the Americas, Asia, and beyond.",
    feature3Title: "🏭 Verified Supplier Network",
    feature3Description: "We collaborate exclusively with audited and trusted manufacturers.",
    feature4Title: "📦 End-to-End Project Management",
    feature4Description: "From supplier selection to final delivery, we coordinate every step for you."
  },

  // Projects Section
  projects: {
    title: "Product Categories",
    description: "Explore our diverse range of product categories and discover the quality solutions we can source for your business needs.",
    subtitle: "What we work with",
    viewDetails: "View Details",
    viewProducts: "View Products",
    hideProducts: "Hide",
    contactForDetails: "For detailed product information and pricing, please contact our team through the form below.",
    lookingForSpecific: "Looking for Something Specific?",
    lookingDescription: "Our sourcing experts can help you find the right manufacturers and suppliers in China for any product category or custom requirements you may have.",
    contactTeam: "Contact Our Team",
    viewAllCategories: "View All Categories",
    allProjects: "All Projects",
    startYourProject: "Start Your Project",
    categories: {
      electronics: "ELECTRONICS",
      machinery: "MACHINERY", 
      tools: "TOOLS",
      packaging: "PACKAGING",
      consumer: "CONSUMER GOODS",
      textiles: "TEXTILES",
      apparel: "APPAREL & BABY PRODUCTS"
    }
  },

  // Blog Section
  blog: {
    title: "Latest China EXPO News & Industry Insights",
    description: "Stay updated with the latest trends, news, and insights from China's manufacturing and export industry.",
    chinaExpoNews: "Latest China EXPO News",
    industryInsights: "Industry Insights",
    industryInsightsDescription: "Market trends, sourcing strategies, and analysis shaping global manufacturing.",
    dailyArticles: "Daily Articles",
    dailyArticlesSubtext: "Fresh industry news and insights – updated every day",
    readMore: "Read More",
    viewAllArticles: "View All Articles",
    lastUpdated: "Last Updated",
    refreshAll: "Refresh All",
    updating: "Updating...",
    autoUpdatesMonthly: "Auto-updates monthly",
    liveFeeds: "Live industry feeds",
    expoUpdates: "China EXPO Updates",
    expoDescription: "Latest news from CIIE, Canton Fair, and major trade events"
  },

  // Contact Section
  contact: {
    title: "Contact Us",
    description: "Ready to start your import project? Contact us for a customized solution.",
    alternateTitle: "Let's get in touch!",
    alternateDescription: "If you have any questions or queries about our services, please send us a contact form or contact our office directly.",
    fullName: "Full Name",
    email: "Email Address",
    company: "Company",
    subject: "Subject",
    message: "Message",
    yourName: "Your Name",
    yourEmail: "Your Email",
    companyName: "Company Name",
    tellUs: "Tell us about your project requirements...",
    attachFiles: "Attach Files",
    filesSelected: "file(s) selected",
    acceptPrivacy: "I accept the Privacy Policy",
    sendMessage: "Send Message",
    phoneLabel: "Phone",
    emailLabel: "Email",
    locationLabel: "Location",
    foundedLabel: "Founded",
    ourOffice: "Our Office",
    howHelp: "How may we help you?",
    requirementsDetail: "Please explain your requirements in as much detail as possible. You can also send us any relevant documentation (plans, details), if you wish. All inquiries will be processed and responded to promptly by our team.",
    attachDocumentation: "Do you need to attach documentation of your project?",
    privacyAccept: "I have read and accept the",
    privacyPolicies: "Privacy Policy",
    contactForm: "Send us a message through our contact form",
    messageSent: "Message Sent Successfully!",
    responseTime: "We'll get back to you within 24 hours.",
    validationError: "Validation Error",
    fillRequiredFields: "Please fill in all required fields.",
    invalidEmail: "Please enter a valid email address.",
    errorTitle: "Error",
    errorMessage: "Failed to send message. Please try again or contact us directly at office@towertech-xm.com",
    responseTime: "We'll get back to you within 24 hours.",
    sending: "Sending..."
  },

  // Footer
  footer: {
    description: "Your trusted partner for risk-free sourcing from China. We connect businesses worldwide with reliable manufacturers and ensure quality at every step.",
    quickLinks: "Quick Links",
    home: "Home",
    about: "About Us", 
    services: "Services",
    projects: "Projects",
    blog: "Blog",
    contact: "Contact",
    legal: "Legal",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    gdprCompliance: "GDPR Compliance",
    languagesWeSpeak: "Languages We Speak",
    rights: "All rights reserved.",
    adminPanel: "Admin Panel",
    scrollToTop: "Scroll to top"
  },

  // Legal Pages
  legal: {
    goBack: "Go Back",
    lastUpdated: "Last Updated: December 2024",
    
    // Terms of Service
    terms: {
      title: "Terms of Service",
      section1: {
        title: "1. Agreement to Terms",
        content: "By accessing and using the Xiamen Tower Technology Co., Ltd. website (towertech-xm.com), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this site."
      },
      section2: {
        title: "2. Company Information",
        company: "Company: Xiamen Tower Technology Co., Ltd.",
        address: "Address: Fujian Province, China",
        phone: "Phone: +86 15381939338",
        email: "Email: office@towertech-xm.com",
        founded: "Founded: 2019",
        services: "Xiamen Tower Technology Co., Ltd. provides import-export and product sourcing services, specializing in connecting international businesses with Chinese manufacturers. Our services include:"
      },
      section3: {
        title: "3. Use License",
        content: "Permission is granted to temporarily download one copy of the materials on Xiamen Tower Technology's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title."
      },
      section4: {
        title: "4. Disclaimer",
        content: "The materials on Xiamen Tower Technology's website are provided on an 'as is' basis. Xiamen Tower Technology makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights."
      },
      section5: {
        title: "5. Limitations",
        content: "In no event shall Xiamen Tower Technology or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Xiamen Tower Technology's website, even if Xiamen Tower Technology or its authorized representative has been notified orally or in writing of the possibility of such damage."
      },
      section6: {
        title: "6. Contact Information",
        content: "For any questions about these Terms of Service, please contact us at office@towertech-xm.com or +86 15381939338."
      }
    },
    
    // Privacy Policy
    privacy: {
      title: "Privacy Policy",
      section1: {
        title: "1. Information We Collect",
        intro: "Xiamen Tower Technology collects information you provide directly to us, such as when you:",
        items: [
          "Fill out our contact forms",
          "Request quotes or information about our services", 
          "Subscribe to our newsletter",
          "Communicate with us via email or phone",
          "Visit our website (through cookies and similar technologies)"
        ]
      },
      section2: {
        title: "2. How We Use Your Information",
        content: "We use the information we collect to provide, maintain, and improve our services, respond to your inquiries, send you marketing communications (with your consent), and comply with legal obligations."
      },
      section3: {
        title: "3. Information Sharing",
        content: "We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law."
      },
      section4: {
        title: "4. Data Security",
        content: "We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction."
      },
      section5: {
        title: "5. Your Rights",
        content: "You have the right to access, update, or delete your personal information. You may also opt out of receiving marketing communications from us at any time."
      },
      section6: {
        title: "6. Contact Us",
        content: "If you have any questions about this Privacy Policy, please contact us at office@towertech-xm.com."
      }
    },
    
    // Cookie Policy  
    cookies: {
      title: "Cookie Policy",
      section1: {
        title: "1. What Are Cookies",
        content: "Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better browsing experience."
      },
      section2: {
        title: "2. Types of Cookies We Use",
        essential: "Essential Cookies: Required for the website to function properly",
        analytics: "Analytics Cookies: Help us understand how visitors use our website",
        preferences: "Preference Cookies: Remember your settings and preferences"
      },
      section3: {
        title: "3. Managing Cookies",
        content: "You can control and manage cookies through your browser settings. Please note that disabling certain cookies may affect website functionality."
      }
    },
    
    // GDPR Compliance
    gdpr: {
      title: "GDPR Compliance",
      section1: {
        title: "1. Data Protection",
        content: "Xiamen Tower Technology is committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR)."
      },
      section2: {
        title: "2. Your Rights Under GDPR",
        rights: [
          "Right to access your personal data",
          "Right to rectification of inaccurate data", 
          "Right to erasure of your data",
          "Right to restrict processing",
          "Right to data portability",
          "Right to object to processing"
        ]
      },
      section3: {
        title: "3. Contact Our Data Protection Officer",
        content: "For any GDPR-related inquiries, please contact our Data Protection Officer at office@towertech-xm.com."
      }
    }
  },

  // FAQ Section
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Everything you need to know about importing successfully",
    takeAdvantage: "Take advantage of the benefits of global importing",
    helpOptimize: "We help you optimize costs and minimize risks in your imports.",
    successfulImporting: "Successful importing begins with experts and rigorous processes.",
    startProject: "Start Your Project",
    questions: [
      {
        question: "What regions do you operate in?",
        answer: "We are based in China and support clients worldwide with sourcing, supplier management, quality control and international delivery from China."
      },
      {
        question: "Do you offer custom product development?",
        answer: "Yes. We take care of the development and supervision of each stage so that your product meets your requirements and quality standards, from concept to final production."
      },
      {
        question: "How do you guarantee product quality?",
        answer: "We carry out comprehensive factory inspections and audits, ensuring that each production run complies with the agreed standards before shipment. Our quality control team is based in China for real-time monitoring."
      },
      {
        question: "Do you provide shipping and logistics management?",
        answer: "We coordinate all logistics management with suppliers and carriers to ensure efficient importation from China to your warehouse, handling customs, documentation, and delivery coordination."
      }
    ]
  },

  // Languages
  languages: {
    en: "English",
    es: "Español",
    de: "Deutsch", 
    sl: "Slovenščina",
    sr: "Српски"
  },

  // Service Process & Additional Services
  serviceProcess: {
    title: "Our Sourcing Process:",
    steps: [
      "Market research & supplier identification",
      "Price negotiation & contract terms",
      "Quality assurance & timeline management",
      "End-to-end logistics coordination"
    ]
  },

  additionalServices: {
    title: "Additional Services:",
    items: [
      "Market entry consulting",
      "Product customization support", 
      "Regulatory compliance assistance",
      "Long-term partnership development"
    ]
  },

  // Service Details (for expanded info sections)
  serviceDetails: {
    supplierSelection: {
      fullDescription: "Our comprehensive supplier selection process includes thorough background checks, factory audits, quality certifications review, and production capability assessments. We verify business licenses, export qualifications, and previous client references to ensure you partner with reliable manufacturers.",
      benefits: [
        "Factory verification & audits",
        "Quality certification checks", 
        "Production capacity evaluation",
        "Financial stability assessment",
        "Previous client reference validation"
      ]
    },
    productDevelopment: {
      fullDescription: "From concept to production, we guide your product development journey. Our team works with manufacturers to create prototypes, refine designs, conduct testing, and ensure your product meets international standards before mass production begins.",
      benefits: [
        "Prototype development",
        "Design optimization",
        "Quality testing & validation", 
        "International standards compliance",
        "Production timeline planning"
      ]
    },
    qualityControl: {
      fullDescription: "Our quality control team conducts pre-production inspections, in-process monitoring, and final product inspections. We use international quality standards and provide detailed reports with photos to ensure your products meet specifications.",
      benefits: [
        "Pre-production inspections",
        "In-process quality monitoring",
        "Final product inspection",
        "Detailed quality reports", 
        "International standard compliance"
      ]
    },
    logisticsManagement: {
      fullDescription: "We coordinate the entire logistics chain from factory pickup to your warehouse delivery. This includes export documentation, customs clearance, shipping arrangements, insurance, and real-time tracking throughout the journey.",
      benefits: [
        "Export documentation handling",
        "Customs clearance assistance",
        "Shipping & freight coordination",
        "Insurance coverage",
        "Real-time shipment tracking"
      ]
    }
  },

  // Products (translated from mockData)
  products: {
    electronics: {
      solarPanels: {
        name: "Solar Panel Systems",
        description: "High-efficiency mono & polycrystalline solar panels for residential and commercial applications"
      },
      electricBikes: {
        name: "Electric Bikes & Scooters", 
        description: "Foldable e-bikes and smart scooters with GPS tracking and long-lasting batteries"
      },
      ledLights: {
        name: "LED Solar Street Lights",
        description: "All-in-one solar street lighting systems with motion sensors and remote control"
      },
      powerBanks: {
        name: "Portable Solar Power Banks",
        description: "High-capacity solar charging stations for outdoor and emergency applications"
      },
      smartHome: {
        name: "Smart Home Devices",
        description: "WiFi-enabled thermostats, smart plugs, and voice control systems for modern homes"
      }
    },
    machinery: {
      cncMachining: {
        name: "CNC Machining Centers",
        description: "3-5 axis precision machining equipment for manufacturing and prototyping"
      },
      conveyor: {
        name: "Industrial Conveyor Systems", 
        description: "Automated belt conveyor lines for packaging, assembly, and material handling"
      },
      hydraulicPress: {
        name: "Hydraulic Press Machines",
        description: "Heavy-duty hydraulic presses for metal forming and industrial applications"
      },
      pneumaticTools: {
        name: "Pneumatic Tools & Components",
        description: "Complete pneumatic systems including compressors, cylinders, and fittings"
      },
      weldingEquipment: {
        name: "Welding Equipment",
        description: "Professional MIG/TIG welders, plasma cutters, and welding accessories"
      }
    },
    tools: {
      measuring: {
        name: "Precision Measuring Equipment",
        description: "Digital calipers, micrometers, and dial indicators for accurate measurements"
      },
      toolSets: {
        name: "Industrial Tool Sets",
        description: "Comprehensive mechanic and electrician tool kits for professional use"
      },
      powerAccessories: {
        name: "Power Tool Accessories", 
        description: "High-quality drill bits, saw blades, and grinding wheels for various materials"
      },
      handTools: {
        name: "Hand Tools",
        description: "Durable wrenches, screwdrivers, pliers, and hex keys for daily operations"
      },
      safetyEquipment: {
        name: "Safety Equipment",
        description: "Professional safety glasses, gloves, hard hats, and hearing protection"
      }
    },
    packaging: {
      packagingMachines: {
        name: "Automatic Packaging Machines",
        description: "Form-fill-seal machines for food, pharmaceutical, and consumer goods packaging"
      },
      labelingSystems: {
        name: "Labeling & Printing Systems",
        description: "Industrial label printers and coding machines for product identification"
      },
      sealingEquipment: {
        name: "Sealing Equipment", 
        description: "Heat sealers, vacuum sealers, and automated tape dispensing systems"
      },
      corrugatedBoxes: {
        name: "Corrugated Boxes & Cartons",
        description: "Custom printed shipping boxes and cartons in various sizes and specifications"
      },
      protectivePackaging: {
        name: "Protective Packaging",
        description: "Bubble wrap, foam inserts, air pillows, and cushioning materials"
      }
    },
    consumer: {
      smartAppliances: {
        name: "Smart Home Appliances",
        description: "Robot vacuums, air purifiers, and smart thermostats for modern living"
      },
      furniture: {
        name: "Flat-Pack Furniture",
        description: "Ready-to-assemble desks, chairs, and storage systems for home and office"
      },
      kitchenGadgets: {
        name: "Kitchen Gadgets", 
        description: "Air fryers, electric kettles, food processors, and innovative cooking tools"
      },
      fitnessAccessories: {
        name: "Fitness Accessories",
        description: "Yoga mats, resistance bands, water bottles, and workout equipment"
      },
      phoneAccessories: {
        name: "Phone Accessories",
        description: "Protective cases, wireless chargers, earbuds, and device stands"
      }
    },
    textiles: {
      technicalFabrics: {
        name: "Technical Fabrics",
        description: "Fire-resistant, waterproof, and anti-bacterial textiles for specialized applications"
      },
      sustainableClothing: {
        name: "Sustainable Clothing",
        description: "Organic cotton, bamboo fiber, and recycled polyester garments"
      },
      homeTextiles: {
        name: "Home Textiles",
        description: "Premium bed sheets, curtains, tablecloths, and decorative fabrics"
      },
      workwear: {
        name: "Workwear & Uniforms", 
        description: "Professional clothing, safety vests, aprons, and corporate uniforms"
      },
      cottonProducts: {
        name: "Basic Cotton Products",
        description: "High-quality t-shirts, towels, socks, and everyday apparel items"
      }
    },
    apparel: {
      babyProducts: {
        name: "Baby Products & Accessories",
        description: "Baby clothes, diapers, feeding bottles, strollers, car seats, and safety products"
      },
      kidsClothing: {
        name: "Kids Clothing & Footwear",
        description: "Children's apparel, school uniforms, sneakers, and seasonal clothing collections"
      },
      adultsFashion: {
        name: "Adults Fashion Clothing",
        description: "Men's and women's casual wear, business attire, sportswear, and fashion accessories"
      },
      maternitywear: {
        name: "Maternity & Nursing Wear", 
        description: "Comfortable maternity clothing, nursing bras, and postpartum recovery garments"
      },
      seasonalCollections: {
        name: "Seasonal Collections",
        description: "Winter coats, summer wear, swimwear, and holiday-themed clothing for all ages"
      },
      footwearAccessories: {
        name: "Footwear & Accessories",
        description: "Shoes, boots, handbags, belts, hats, and fashion jewelry for men, women, and children"
      }
    }
  },

  // Common UI Elements
  ui: {
    backButton: "Go Back",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    view: "View",
    hide: "Hide",
    show: "Show",
    more: "More",
    less: "Less",
    keyBenefits: "Key Benefits:"
  },

  // Cookie Consent Banner
  cookies: {
    bannerTitle: "We use cookies",
    bannerDescription: "We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. By clicking \"Accept All\", you consent to our use of cookies.",
    acceptAll: "Accept All",
    declineOptional: "Decline Optional"
  },

  // International Partners
  partners: {
    title: "Our International Partners",
    subtitle: "Trusted collaborators who extend our reach and support clients across key global markets.",
    websiteLabel: "Website",
    becomePartner: "Interested in becoming an official distribution partner?",
    contactCta: "Get in Touch",
    valsol: {
      tagline: "Chilean Distribution Partner",
      description: "Official partner of Xiamen Tower Technology Co., Ltd. for Chile.\nSpecialized in direct sourcing and import operations from China, supporting local clients with reliable supply chain solutions and effective market coordination."
    }
  }
};